export const HOTSPOT_FLYOUT_UPDATE: string = 'onUpdateHotspotFlyout';
export const HOTSPOT_CLICK: string = 'onClickHotspot';
export const HOTSPOT_NAVIGATION_CLICK: string = 'onClickHotspotNavigation';

// Adobe Client Data Layer Events (ACDL - Data Client Layer)
export const ACDL_CONSENT_UPDATED: string = 'consent:updated';
export const ACDL_PRE_HIDING_DEACTIVATED: string = 'pre-hiding:deactivated';
export const ACDL_FPID_CACHE_HIT: string = 'fpid:cache-hit';
export const ACDL_FPID_FETCH_START: string = 'fpid:fetch-start';
export const ACDL_FPID_FETCH_SUCCESS: string = 'fpid:fetch-success';
export const ACDL_FPID_FETCH_FAILED: string = 'fpid:fetch-failed';
// Embedded form-iframe events (forwarded into the ACDL by FormMessageBridge; xdmtracker maps them to XDM)
export const ACDL_FORM_OPENED: string = 'form:opened';
export const ACDL_FORM_FIRST_INTERACTION: string = 'form:first-interaction';
export const ACDL_FORM_SUBMIT: string = 'form:submit';
export const ACDL_FORM_ERROR: string = 'form:error';

export const ACDL_SEARCH_LOADED: string = 'search:loaded';
export const ACDL_SEARCH_UPDATED: string = 'search:updated';
export const ACDL_SEARCH_RESET: string = 'search:reset';
export const ACDL_SEARCH_BY_ORDER_NUMBER_SUCCESS: string = 'search:orderNumber:success';
export const ACDL_SEARCH_BY_ORDER_NUMBER_NO_RESULT: string = 'search:orderNumber:noResult';
export const ACDL_ADD_TO_WATCHLIST: string = 'addToWatchlist';
export const ACDL_REMOVE_FROM_WATCHLIST: string = 'removeFromWatchlist';
export const ACDL_ADD_TO_COMPARE: string = 'addToCompare';
export const ACDL_REMOVE_FROM_COMPARE: string = 'removeFromCompare';
// Viewed-vehicle state for TopUsed (sets component.topUsed.vehicle; read by later watchlist/compare/orderNumber events)
export const ACDL_VEHICLE_UPDATE: string = 'vehicle:update';

// Link clicks. xdmtracker maps dc:title → eVar15, @type → eVar16, xdm:linkURL → eVar17.
// Standard page fields come from the tracking definition defaults.
export const ACDL_CMP_CLICK: string = 'cmp:click';

// Flyout family (GKKWM-1174) — generic across every component built on <man-flyout>. The specific
// flyout is identified by eVar16 (@type) from its own seeded component data layer, so a new flyout
// inherits this tracking without a Launch change. See man-flyout/man-flyout.tracking.ts.
export const ACDL_FLYOUT_SHOWN: string = 'flyout:shown';
export const ACDL_FLYOUT_CLOSED: string = 'flyout:closed';
export const ACDL_FLYOUT_CTA_CLICK: string = 'flyout:cta:click';

// Video family (GKKWM-1342) — emitted by man-video.tracking.ts for the Ignite player. The names are
// unchanged from the Vimeo implementation they replace, so the Tags definition and the Analytics
// reports downstream need no change. Only play + the four quartiles map to Analytics events
// (event20-24 via VIDEO_EVARS); loaded/pause/ended are data-layer only.
export const ACDL_VIDEO_LOADED: string = 'video:loaded';
export const ACDL_VIDEO_PLAY: string = 'video:play';
export const ACDL_VIDEO_PAUSE: string = 'video:pause';
export const ACDL_VIDEO_ENDED: string = 'video:ended';
export const ACDL_VIDEO_PLAYED_25: string = 'video:played:25';
export const ACDL_VIDEO_PLAYED_50: string = 'video:played:50';
export const ACDL_VIDEO_PLAYED_75: string = 'video:played:75';
export const ACDL_VIDEO_PLAYED_95: string = 'video:played:95';
